interface LinkClick {
  /** The anchor's resolved absolute `href`. */
  href: string;
  currentUrl: string;
  button: number;
  /** Any of ctrl, meta, shift or alt was held. */
  modified: boolean;
  hasTarget: boolean;
  hasDownload: boolean;
}

/// The router location for a click that should navigate inside the app, or null when the browser
/// should handle it. A full page load would tear down the open Hand panel and its conversation.
export function copilotInternalNavigationTarget(click: LinkClick): string | null {
  if (click.modified || click.button !== 0 || click.hasTarget || click.hasDownload) return null;
  let target: URL;
  let current: URL;
  try {
    target = new URL(click.href);
    current = new URL(click.currentUrl);
  } catch {
    return null;
  }
  if (target.origin !== current.origin) return null;
  const samePage = target.pathname === current.pathname && target.search === current.search;
  if (samePage && target.hash !== "") return null;
  return `${target.pathname}${target.search}${target.hash}`;
}

type PanelMode = "desktop" | "side-sheet" | "bottom-sheet";

/// What the panel does when a link hands off to the router. The dock sits beside the page so it
/// stays; full page and sheets cover the destination, so they step aside (the conversation lives
/// in the provider, not the panel, and survives either).
export function copilotNavigationEffect(
  mode: PanelMode,
  isExpanded: boolean,
): "none" | "collapse" | "close" {
  if (mode !== "desktop") return "close";
  return isExpanded ? "collapse" : "none";
}
